import type { SVGProps } from "react";

import {
  Calendar,
  Hash,
  List,
  Tag,
  ToggleLeft,
  Type,
  UserRound,
} from "@/shared/foundation/icons";

import type { FilterDataType } from "./FilterSchema";

/**
 * Single icon per `FilterDataType`. Reused by the field picker rows and the
 * right-pane field header so the type cue is consistent.
 *
 * Per-definition overrides (e.g. fingerprint for resource-id flavored
 * string fields) are supplied via `FilterDefinition.icon` at the picker
 * and form-header callsites — this helper is the type-default fallback.
 */
export function FieldTypeIcon({
  type,
  className,
}: {
  type: FilterDataType;
  className?: SVGProps<SVGSVGElement>["className"];
}) {
  switch (type) {
    case "string":
      return <Type className={className} />;
    // `metric` reuses the numeric `#` glyph — a metric chip is visually
    // identical to a numeric one (only `Filter["type"]` differs).
    case "numeric":
    case "metric":
      return <Hash className={className} />;
    case "date":
      return <Calendar className={className} />;
    case "boolean":
      return <ToggleLeft className={className} />;
    case "set":
      return <Tag className={className} />;
    case "enum":
      return <List className={className} />;
    case "identity":
      return <UserRound className={className} />;
  }
}
